import { useEffect, useRef } from 'react'
import Message from './message'
import Loader from '../all/loader'

const MessagesContainer = ({messages, loaded, setLoaded, ws}) => {

    const endOfMessagesRef = useRef(null)
    
    useEffect(() => {
        endOfMessagesRef.current.scrollIntoView()
    }, [messages, loaded])

    return (
        <>
            <div className='messages-container'>

                {loaded ? (
                    <>
                        <span className={loaded === 1 ? 'animate' : ''} onAnimationEnd={() => setLoaded(2)}>
                            {Array.isArray(messages) && messages.map((message, index) => ( // name, level, avatar, message
                                <Message message={message.message} rank={message.rank} name={message.username} level={message.level} avatar={message.avatar} hide_country={message?.hide_country} country={message?.country} hide_level={message?.hide_level} key={index}/>
                            ))}
                        </span>
                    </>
                ) : (
                    <div className='unloaded'>
                        <Loader/>
                    </div>
                )}

                <span ref={endOfMessagesRef}/>
            </div>

            <style jsx>
                {`
                    .messages-container {
                        width: 100%;
                        height: 100%;

                        display: flex;
                        flex-direction: column;

                        overflow-y: scroll;
                        overflow-x: hidden;
                        margin-bottom: 15px;
                    }

                    .animate {
                        animation-duration: .65s;
                        animation-name: slidein;
                        animation-timing-function: ease;
                    }

                    .unloaded {
                        height: 100%;
                        width: 100%;

                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    @keyframes slidein {
                        from {
                            transform: translateX(330px);
                        }
                      
                        to {
                            transform: translateX(0px);
                        }
                    }

                    .messages-container::-webkit-scrollbar {
                        display: none;
                    }
                `}
            </style>
        </>
    )
}

export default MessagesContainer